import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { adminService } from '../../services/admin.service';
import { TenantComponentStatus, TenantActivityType } from '../../../app/app.constants';

@Component({
  selector: 'app-tenant-export',  
  templateUrl: './tenant-export.component.html',
  styleUrl: './tenant-export.component.css'
})
export class TenantExportComponent implements OnInit {
    public componentStatusList : any = [];
    public tenantComponentStatus:any = TenantComponentStatus;  
    
    public statusInterval:any = null;
    public reloadTenantList:boolean = false;
  
    public exportStatusText:any = TenantComponentStatus[1];  
    public exportBtnDisabled:boolean = false;
    
    constructor(public dialogRef: MatDialogRef<TenantExportComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any,
      private readonly adminService: adminService) { }
     
    ngOnInit() {
      this.getTenantCompStatus();
    }
  
    getTenantCompStatus() {    
      this.adminService.getComponentStatusByTenantId(this.data.data.tenantId, TenantActivityType.EXPORT).subscribe((result:any)=> {      
        this.componentStatusList = result;        
      })  
    }
  
    /** Cancel the pop-up */
    onCloseClick(): void {
      this.dialogRef.close(this.reloadTenantList);
    }
  
    onExportClick() {      
      console.log('Export');
    }
}
